<div style="margin-bottom: 10px;">
    <div class="px-4 flex flex-row flex-wrap justify-between items-center content-center">
        <h3 style="font-size: 16px;">Vocero</h3>
        <button type="button" mat-raised-button mat-button-sm color="primary" *ngIf="addPermission"
            class="me-4 mb-4" (click)="openDialog()">
            Agregar vocero
        </button>
    </div>


    <ngx-datatable [loadingIndicator]="loading" class="material min" [messages]="messages" [columnMode]="'force'" [headerHeight]="45"
    [footerHeight]="45" [rowHeight]="70" [scrollbarV]="true" [scrollbarH]="true" [rows]="list$ | async">

        <ngx-datatable-column name="#" [width]="10" [canAutoResize]="false" [sortable]="false" [draggable]="false">
            <ng-template let-value="value" ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
                {{ rowIndex + 1 }}
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Vocero" prop="vocero">
            <ng-template let-value="value" ngx-datatable-cell-template>
                {{ value.nombres }} {{ value.apellidos }}
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Cargo" prop="cargo">
            <ng-template ngx-datatable-cell-template let-row="row">
                <ng-container *ngIf="row?.cargos?.length; else cargoTexto">
                    <ng-container *ngFor="let c of row.cargos; let i = index">
                        <span>{{ c.descripcion }}</span><span *ngIf="i < row.cargos.length - 1">, </span>
                    </ng-container>
                </ng-container>
                <ng-template #cargoTexto>{{ row?.cargo || '' }}</ng-template>
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Correo" prop="vocero.emails">
            <ng-template let-value="value" ngx-datatable-cell-template>
                <div *ngFor="let em of value">{{em.email}}</div>
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Teléfono" prop="vocero.telefonos">
            <ng-template let-value="value" ngx-datatable-cell-template>
                <div *ngFor="let tl of value">{{tl.telefono}}</div>
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Acciones" prop="id" [width]="200" [canAutoResize]="false" [sortable]="false">
            <ng-template let-value="value" ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
                <button [disabled]="row.vocero.tiposPersona === '1'"
                    *ngIf="editPermission" mat-stroked-button mat-button-sm color="primary"
                    type="button" class="me-2" (click)="edit(row)">
                    <mat-icon>edit</mat-icon>
                </button>
                <button [disabled]="row.vocero.tiposPersona === '1'"
                    *ngIf="deletePermission" mat-stroked-button mat-button-sm
                    type="button" (click)="delete(value)">
                    <mat-icon>delete</mat-icon>
                </button>
            </ng-template>
        </ngx-datatable-column>

    </ngx-datatable>
</div>
